goog.provide('el8.app.settings.schedule');

goog.require('el8.app.settings.util');
goog.require('el8.service.urls');
goog.require('el8.template.app.settings.sections');
goog.require('el8.util.consts');

el8.app.settings.schedule = (function() {
  var that = {};
  var $container;

  that = {
    init: function(_container) {
      $container = _container;
      $container.attr('id', 'settings-schedule');
    },
    showTabFn: function() {
      $container.parent().css('padding', '0');
      el8React.renderScheduleSettings($container.attr('id'));
    },
    hideTabFn: function(_container) {
      $container = _container;
      $container.parent().css('padding', '');
    }
  };

  return that;
})();
